<template>
  <div class="vipInfo">
    <!-- Header -->
    <Header headerTitle="VIP"></Header>
    <section>
    <div v-for="(vipInfo,index) in vipInfos" :key="index" style="margin-top:25px">
       <div class="vipBackground"><span class="vipCard">{{$t('m.vipInfo.cardNumber')}}</span><div>{{vipInfo.cardNo}}</div></div>
      <div class="vipText" v-if="$t('m.vipInfo.language')=='en_US'">
        <h6>{{$t('m.vipInfo.rights')}}</h6>
        <p>{{vipInfo.discount*100}}% off (can be used in conjunction with other offers)</p>
        <span>Effective from:{{vipInfo.createDate}} to {{vipInfo.validityDate}}</span>
      </div>
       <div class="vipText" v-else>
        <h6>{{$t('m.vipInfo.rights')}}</h6>
        <p>享受{{vipInfo.discount*10}}折优惠(可与其他优惠同时使用)</p>
        <span>享受有效期:: {{vipInfo.createDate}}至{{vipInfo.validityDate}}</span>
        <div>
        </div>
      </div>
    </div>
      <div class="vipText">
         <b-link @click="show" style="color:#2c3e50;border-bottom: 0.09rem solid black;text-decoration: none;font-weight:650">VIP卡使用说明</b-link>
         <b-link style="margin-left: 1rem;color:#2c3e50;border-bottom: 0.09rem solid black;text-decoration: none;font-weight:650" @click="bindCard()">{{$t('m.bindingVip.title')}}</b-link>
      </div>

    </section>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
     <b-modal
          ref="introduction"
          class="introduce"
          ok-only
          :ok-title="$t('m.home.ok')"
      >
      <h5 style="font-weight:bold">
         {{$t('m.home.introduceTitle')}}
      </h5>
        <p
            class="my-3"
            style="text-align:left;margin-bottom:5px !important;padding:0 25px;font-size:15px;white-space:pre-line"
        >{{$t('m.home.introduction')}}</p>
       <p style="font-size:0.9rem;font-weight:bold;margin-top:1rem" >
         {{$t('m.home.introduceFooter')}}
      </p>
      <a style="color:#0066B1;font-size:0.9rem;margin-top:1rem;font-weight:light"  href="tel:400-115-0606">400-115-0606</a>
      </b-modal>
  </div>
</template>
<script>
import { vipCardInfo } from "@/api/vip.js";
export default {
  name: "vipInfo",
  data() {
    return {
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      vipInfos: [] //vip详情
    };
  },
  methods: {
    show(){
        this.$refs['introduction'].show();
    },
    bindCard(){
       this.$router.push("/bindingVip");
    },
    vipCard: function() {
      // var openId = "obgbnwZMtJLBqrmHu-8Eza44xw2o";
      var openId = localStorage.getItem("openId");
      vipCardInfo({ openId: openId }).then(
        response => {
          if (response.data.status == 200) {
            response.data.result.forEach(element => {
				console.log("lyyyyyyyyyyy")
				console.log(element)
              if(element.serviceType != 3){
                this.vipInfos.push(element)
              }
            });
            this.vipInfos.forEach(element => {
               element.validityDate = element.validityDate.substr(0,10)
            });
            // this.vipInfo.validityDate = this.vipInfo.validityDate.substr(0,10);
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  created() {
    this.vipCard();
  }
};
</script>
<style scoped>
.vipInfo section {
  margin: 0 13px;
  margin-top: 20px;
}
.vipInfo .vipBackground .vipCard{
  position:absolute;
  margin-top: -20px;
  font-size: 16px;
}
.vipInfo .vipBackground div{
  margin-left: 10%;
}
.vipInfo .vipBackground {
  color: #ecdfcc;
  font-size: 1.2rem;
  box-shadow: 1px 0px 1px #efefef;
  border-radius: 10px;
  background: url("../../assets/img/vipbg.png") no-repeat;
  background-size: 100% 100%;
  padding: 90px 0 0 35px;
  text-align: left;
  -moz-background-size: 100% 100%;
  height: 190px;
}
.vipInfo .vipText {
  margin-top: 30px;
  text-align: left;

}
.vipInfo .vipText h6 {
  font-size: 1.01rem;
  font-weight: bold;

}
.vipInfo .vipText p {
  color: #666;
}
.vipInfo .vipText span {
  color: rgb(148, 148, 148);
  font-size: 0.89rem;
}
</style>


